module.exports = __webpack_public_path__ + "img/aircraft_factory_small.efdb418f.png";